// เช็คทุกครั้งที่เปิดหน้าว่า session ที่ถืออยู่ยังเป็นคนเดียวกับที่ IAM รู้จัก
//
// เหตุที่ต้องมี: token ยังไม่หมดอายุ ไม่ได้แปลว่ายังเป็นคนเดิม ผู้ใช้อาจสลับบัญชี
// ที่ระบบอื่นในเครือแล้วกดลิงก์เข้ามา แท็บนี้จะยังแสดงข้อมูลของคนเดิมอยู่
//
// ทำงานครั้งเดียวต่อการโหลดหน้า (ไม่ใช่ทุกครั้งที่เปลี่ยนหน้าในแอป) และไม่บล็อกจอ —
// ถ้าเช็คไม่ได้ก็ใช้ของเดิมต่อ ดู checkSsoIdentity ใน lib/iam-sso.ts
import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { checkSsoIdentity } from "../lib/iam-sso";
import { sessionSet } from "./session-slice";

export function useIdentityCheck(): void {
  const session = useAppSelector((s) => s.session.current);
  const dispatch = useAppDispatch();
  const ran = useRef(false);

  useEffect(() => {
    // เฉพาะคนที่เข้ามาทาง SSO — คน login ด้วยรหัสผ่านไม่ได้ผูกกับ cookie ของ IAM
    // การไปสลับให้เป็นตัวตนจาก IAM จะกลายเป็นเปลี่ยนบัญชีให้เขาโดยไม่ได้ขอ
    if (ran.current || session?.via !== "sso") return;
    ran.current = true;

    void checkSsoIdentity(session).then((next) => {
      if (!next) return; // คนเดิม หรือถามไม่ได้ — ไม่ต้องทำอะไร
      dispatch(sessionSet(next));
      // ข้อมูลบนจอทั้งหมดเป็นของคนเก่า (แบรนด์ที่เข้าถึงได้ก็คนละชุด) — โหลดใหม่ทั้งหน้า
      // ง่ายและถูกต้องกว่าไล่ invalidate query ทีละตัวแล้วหวังว่าครบ
      location.reload();
    });
  }, [session, dispatch]);
}
